export const en = {
  navbar: {
    home: 'Home',
    gallery: 'Model Gallery',
    tabGallery: 'Gallery',
    tabProfile: 'Profile',
    sellers: 'Sellers',
    about: 'About Us',
    contact: 'Contact',
    signIn: 'Sign In',
    signOut: 'Sign Out',
    profile: 'My Profile',
    sellerPanel: 'Seller Panel',
    adminPanel: 'Admin Panel',
    moderatorPanel: 'Moderator Panel',
    messages: 'Messages',
    darkMode: '🌙 Dark Mode',
    lightMode: '☀️ Light Mode',
    logoutError: 'An error occurred while signing out.',
    defaultUser: 'User',
  },
  hero: {
    title: "Welcome to Turkey's 3D Marketplace!",
    subtitle: 'Meet thousands of 3D models, professional designers and local manufacturers. Turn your dream projects into reality, take your creativity beyond limits!',
    cta: 'Get Started',
    videoAlt: '3DEra platform introduction video - 3D printing technology and marketplace services',
    videoFallback: 'Your browser does not support video playback. Please use a modern browser to explore the 3DEra platform.',
  },
  footer: {
    faq: 'FAQ',
    blog: 'Blog',
    privacy: 'Privacy Policy',
    terms: 'Terms of Use',
    distanceSales: 'Distance Sales Agreement',
    kvkk: 'KVKK Privacy Notice',
    copyright: 'All rights reserved.',
    legalLinks: 'Legal and information links',
    tagline: 'Where 3D printing comes together. Design, sell, and order — all in one place.',
    exploreHeading: 'Explore',
    legalHeading: 'Legal & Support',
    marketplace: 'Marketplace',
    sellers: 'Sellers',
    about: 'About',
    contact: 'Contact',
    becomeSeller: 'Become a Seller',
    followUs: 'Follow us',
  },
  cookie: {
    message: 'This website uses cookies to improve your experience and for analytics purposes. Third-party advertising services (Google AdSense) may also use cookies. For more information, please review',
    privacyLink: 'our Privacy Policy',
    reviewText: '.',
    accept: 'Accept All',
    reject: 'Reject',
  },
  home: {
    seoDesc: "Turkey's largest 3D model marketplace",
    featuredTitle: 'Featured Models',
    featuredViewAll: 'Model Gallery →',
    mostViewedTitle: 'Most Viewed Models',
    noFeatured: 'No featured products yet.',
    price: '₺',
    valueProp: {
      heading: 'Earn while others discover',
      subheading: '3DEra connects makers with idle 3D printers to buyers looking for affordable, high-quality prints.',
      sellerTitle: 'Got a 3D printer at home?',
      sellerDesc: 'Turn your idle capacity into income. Take orders on your own schedule and from people near you.',
      sellerBullet1: 'Transparent commission, know what you earn',
      sellerBullet2: 'Set your own hours and pricing',
      sellerBullet3: 'Tax-exempt or company registration option',
      sellerCtaGuest: '✨ Sign Up and Start Selling',
      sellerCtaAuth: '🚀 Become a Seller',
      buyerTitle: 'Find what you need, at a fair price',
      buyerDesc: 'Get the 3D product you want, hassle-free, from local makers with fast shipping.',
      buyerBullet1: 'Friendly and trusted local makers',
      buyerBullet2: 'Ready-made models or custom design orders',
      buyerBullet3: 'Fast and safe delivery',
      buyerCta: 'Explore Products',
    },
    blogTeaser: {
      heading: 'From the Blog',
      viewAll: 'View All',
      readMore: 'Read More',
      exploreAll: 'Explore More',
    },
  },
  marketplace: {
    title: '3D Model Gallery',
    subtitle: 'Choose from thousands of ready-made 3D models and custom drawing files',
    readyModels: '📦 Ready Models',
    customDrawings: '✏️ Custom Drawings',
    searchPlaceholder: 'Search products...',
    clearSearch: 'Clear search',
    ad: 'Ad',
    filters: 'Filters',
    category: 'Category',
    all: 'All',
    sortDefault: 'Default',
    sortNewest: 'Newest',
    sortPriceLow: 'Price (Low)',
    sortPriceHigh: 'Price (High)',
    sortPopular: 'Popular',
    noProducts: 'No products found.',
    loading: 'Loading...',
    featured: 'Featured',
    categories: {
      figurine: 'Figurine',
      decoration: 'Decoration',
      toy: 'Toy',
      jewelry: 'Jewelry & Accessories',
      functional: 'Functional',
      architectural: 'Architectural',
      art: 'Art',
      other: 'Other',
    },
  },
  sellers: {
    title: 'Sellers',
    subtitle: 'Our trusted sellers providing 3D printing services',
    nearYou: 'Best 3D printer owners near you',
    locationPrompt: "Let's Find the Closest Sellers to You?",
    locationDesc: 'Allow location access to find 3D modelers near your location',
    allow: 'Allow',
    notNow: 'Not Now',
    locationActive: 'Showing closest sellers to your location',
    reset: 'Reset',
    list: 'List',
    map: 'Map',
    searchPlaceholder: 'Search seller name, email or specialty...',
    clearSearch: 'Clear search',
    found: 'sellers found',
    loading: 'Loading sellers...',
    demoData: 'Showing demo data',
    previous: '‹ Previous',
    next: 'Next ›',
  },
  sellerProfile: {
    notFound: 'Seller not found',
    backToSellers: 'Back to Sellers',
    back: 'Back',
    storeLogo: 'Store logo',
    defaultAvatar: 'Default avatar',
    design: 'Design',
    printing: 'Printing',
    designService: 'Design Service',
    printingService: 'Printing Service',
    reviews: 'reviews',
    loading: 'Loading seller profile...',
    sendMessage: 'Send Message',
    viewStore: 'View Store',
    products: 'Products',
    location: 'Location',
  },
  productDetail: {
    loading: 'Loading product...',
    notFound: 'Product Not Found',
    backToMarketplace: 'Return to Marketplace',
    back: 'Back',
    gallery: 'Model Gallery',
    fileAvailable: '3D File Available',
    zoomIn: 'Zoom In',
    removeFromFavorites: 'Remove from Favorites',
    addToFavorites: 'Add to Favorites',
    saved: 'Saved',
    save: 'Save',
    share: 'Share',
    shareText: 'Check out this product:',
    linkCopied: 'Link copied!',
    description: 'Product Description',
    seller: 'Seller',
    viewStore: 'View Store',
    quantity: 'Quantity',
    addToCart: 'Add to Cart',
    buyNow: 'Buy Now',
  },
  about: {
    seoTitle: 'About Us - 3DEra',
    seoDesc: 'Platform democratizing 3D printing technology',
    title: 'About Us',
    heading: 'We Are Democratizing 3D Printing Technology',
    paragraph1: 'Hello! As 3D Era, we are a young startup aiming to make 3D printing technology more accessible to everyone. Our market observations showed us that the high cost of 3D printers and the technical knowledge required prevent many people from benefiting from this technology.',
    paragraph2: "At the same time, we realized there are many people who own 3D printers but don't use them or can't utilize them properly. This is where we developed a solution that makes both sides happy.",
    paragraph3: 'Our platform enables 3D printer owners to utilize their machines and earn additional income, while allowing users who need 3D printing to access this service at affordable prices and easily. Our goal is to democratize 3D printing technology and ensure all segments of society benefit from this innovative technology.',
    imageAlt: 'Production with 3D printing technology',
    teamTitle: 'Our Team',
    teamDesc: 'We work remotely with our team spread across 5+ cities in Turkey, providing 24/7 active service. Thanks to our contacts in different locations, we ensure a fast and seamless onboarding process for our users.',
    teamCities: '5+ Cities',
    teamCitiesDesc: 'Distributed team across Turkey',
    teamRemote: 'Remote Work',
    teamRemoteDesc: '24/7 active and online support',
    teamSupport: 'Quick Start',
    teamSupportDesc: 'Seamless onboarding process',
  },
  contact: {
    title: 'Contact & Support',
    subtitle: 'We are here for your questions, suggestions, or support requests. We will respond to you as soon as possible.',
    formTitle: 'Get In Touch With Us',
    formDesc: 'You can reach us by filling out the form below.',
    emailAlt: 'you can also send an email. Our response time is usually',
    hours24: '24 hours',
    within: '.',
    maintenance: 'Site under maintenance. Form cannot be sent at this time.',
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'Email',
    phone: 'Phone',
    optional: 'Optional',
    subject: 'Subject',
    message: 'Message',
    firstNamePlaceholder: 'Your first name',
    lastNamePlaceholder: 'Your last name',
    emailPlaceholder: 'example@email.com',
    phonePlaceholder: '+1 XXX XXX XXXX',
    subjectPlaceholder: 'Subject of your message',
    messagePlaceholder: 'Write your message here...',
    attachment: 'Attachment',
    dragFiles: 'Drag files or',
    select: 'select',
    fileTypes: 'Image, video, or PDF — Max.',
    fileLimit: 'files, 10MB',
    uploading: 'Uploading files...',
    sending: 'Sending...',
    maintenanceBtn: 'Maintenance',
    send: 'Send',
    success: 'Your message was sent successfully! We will get back to you soon.',
    maxFiles: 'At most',
    filesLimit: 'files can be added.',
    unsupportedType: 'unsupported file type. (You can add image, video or PDF)',
    fileTooLarge: 'is too large. Maximum file size is 10MB.',
    fillRequired: 'Please fill in all required fields.',
    rateLimit: 'Please wait 1-2 minutes and try again.',
    sendFailed: 'Could not send. Please try again.',
    genericError: 'An error occurred. Please try again.',
    loginToAttach: 'To add files',
    signIn: 'sign in',
    onlyLetters: 'You can only use letters',
  },
  sss: {
    seoTitle: 'Frequently Asked Questions (FAQ) - 3DEra',
    title: 'Frequently Asked Questions',
    subtitle: 'You can find answers to your questions about 3DEra here.',
    backHome: '← Home',
    notFound: "Couldn't find the answer you were looking for?",
    contactUs: 'Contact Us →',
    general: 'General',
    forSellers: 'For Sellers',
    forBuyers: 'For Buyers',
    technical: 'Technical',
    questions: {
      whatIs3DEra: { q: 'What is 3DEra?', a: '3DEra is a digital marketplace where 3D printed products can be bought and sold. Sellers can turn their idle 3D printers at home into a source of income; buyers can find customization options for nearly all products at cost-effective prices.' },
      isFree: { q: 'Is it free to use 3DEra?', a: 'Yes, signing up and browsing products on 3DEra is completely free. Opening a store and listing products is also free for sellers. We only take a small commission on successful sales.' },
      fileFormats: { q: 'What file formats are supported?', a: 'Popular 3D file formats such as STL, OBJ, FBX, GLTF/GLB, STEP, IGES are supported, as well as technical drawing formats like PDF and DWG.' },
      becomeSeller: { q: 'How can I become a seller?', a: 'After creating an account, you can apply by clicking the "Become a Seller" button on your Profile page. Once your application is approved, you can start uploading your products.' },
      approvalTime: { q: 'How long does product approval take?', a: 'Products are usually reviewed and approved within 6 hours. During busy periods, this may take slightly longer. You can track your product status from your Seller Panel.' },
      whatToSell: { q: 'What types of products can I sell?', a: 'You can sell any type of product made with 3D printing: decorative figurines, functional parts, prototypes, personalized gifts, jewelry and more. Products just need to comply with legal and platform rules.' },
      addEmployees: { q: 'Can I add employees to my store?', a: 'Yes, you can invite employees via email from the "Team Management" section in the Seller Panel. You can assign Manager or Staff roles and set expiration dates.' },
      payment: { q: 'How is payment made?', a: 'The payment system is currently being integrated. Our secure payment infrastructure will be active soon. For now, you can place orders by messaging sellers directly.' },
      trackOrder: { q: 'How do I track my order?', a: 'You can track your order status in real-time from the order history section in your profile. You will also receive notifications when order status changes.' },
      returns: { q: 'Can I return or exchange?', a: 'You can request a return for products that do not match the description or arrive damaged. Please review our Distance Sales Agreement for details.' },
      whatIs3DPrinting: { q: 'What is 3D printing?', a: '3D printing (additive manufacturing) is the process of transforming a digital design into a physical object layer by layer. There are different methods such as FDM, SLA, SLS. In FDM, the most common method, the product is created by depositing melted plastic filament in layers.' },
      photoTo3D: { q: 'Can I create a 3D model from a photo?', a: "Yes! With 3DEra's \"Photo to 3D\" feature, you can upload your photo and get an AI-powered 3D model prediction. This feature is currently in beta." },
      problem: { q: 'What should I do if I encounter a problem?', a: 'You can reach us using the form on our Contact page. You can also send feedback quickly via the "Feedback" button on the right side of the page.' },
    },
  },
  blog: {
    seoTitle: 'Blog - 3D Printing Guides and Tips | 3DEra',
    title: '3DEra Blog',
    subtitle: 'Guides, tips and news about the world of 3D printing',
    reading: 'read',
    readArticle: 'Read Article →',
    ctaSubtitle: 'Keep following us for more content.',
    comingSoon: 'Coming Soon →',
    newContent: 'New content is being prepared. Stay tuned!',
    backToBlog: '← Back to Blog',
    relatedPosts: 'Related Posts',
    categories: { guide: 'Guide', material: 'Material', comparison: 'Comparison', business: 'Business', troubleshooting: 'Troubleshooting' },
    posts: {
      whatIs3DPrinting: {
        title: 'What is 3D Printing? A Comprehensive Guide for Beginners',
        excerpt: 'Discover the fundamentals of 3D printing technology, how it works, and its applications. Compare FDM, SLA and SLS methods.',
        content: `3D printing is a manufacturing technology that transforms a digital design into a physical object layer by layer. Also known as "additive manufacturing," this method works by adding material rather than removing it, unlike traditional manufacturing techniques.

## How Does It Work?

The 3D printing process consists of three basic steps:

1. **Design**: A 3-dimensional digital model is created using CAD software (such as Fusion 360, Tinkercad, Blender).
2. **Slicing**: The model is divided into thin layers by slicing software (such as Cura, PrusaSlicer) and converted into printer instructions (G-code).
3. **Printing**: The 3D printer follows these instructions, depositing material layer by layer to create the object.

## Common 3D Printing Methods

### FDM (Fused Deposition Modeling)
The most common and affordable method. Thermoplastic filament is melted and deposited layer by layer. Ideal for home users and hobby projects.

### SLA (Stereolithography)
Works by curing liquid resin with UV light. Provides much higher detail and smoother surfaces than FDM. Preferred for miniatures, jewelry molds, and dental applications.

### SLS (Selective Laser Sintering)
Uses a laser to sinter powdered material. Does not require support structures and is used in industrial applications.

## Where Is It Used?

- **Prototyping**: Rapid prototype production during product development
- **Education**: Anatomy models, engineering parts
- **Medicine**: Prosthetics, surgical planning models, dental implants
- **Architecture**: Building and city scale models
- **Hobby**: Figurines, home decoration, cosplay parts
- **Industry**: Spare parts, jigs and fixtures

## Choosing Your First 3D Printer

For beginners, FDM printers are the best option. Quality entry-level models can be found in the $50-$200 range. Print area (at least 220x220mm), filament compatibility, and community support are the most important criteria.

On 3DEra, you can discover thousands of print-ready models designed by professionals and start your own 3D printing journey.`
      },
      filamentTypes: {
        title: 'Best 3D Printer Filament Types and Applications',
        excerpt: 'PLA, ABS, PETG, TPU and more. Which filament type suits which project? Comparative guide with pros and cons.',
        content: `Filament selection is one of the most important factors directly affecting 3D print quality. Each filament type has its own unique properties, advantages, and ideal use cases.

## PLA (Polylactic Acid)

PLA is the most popular and most suitable filament type for beginners.

- **Print temperature**: 190-220°C
- **Bed temperature**: 20-60°C (optional)
- **Advantages**: Easy to print, odorless, biodegradable, wide color range
- **Disadvantages**: Low heat resistance (55-60°C), brittle
- **Ideal use**: Decorative objects, prototypes, figurines, educational materials

## ABS (Acrylonitrile Butadiene Styrene)

A durable filament preferred in industrial applications.

- **Print temperature**: 220-260°C
- **Bed temperature**: 90-110°C (mandatory)
- **Advantages**: High heat resistance, impact resistance, can be smoothed with acetone
- **Disadvantages**: Warping issues, unpleasant odor, requires enclosed printer
- **Ideal use**: Functional parts, automotive parts, outdoor use

## PETG (Polyethylene Terephthalate Glycol)

A filament that combines the easy printability of PLA with the durability of ABS.

- **Print temperature**: 220-250°C
- **Bed temperature**: 70-90°C
- **Advantages**: Strong, flexible, chemical resistance, food-safe, UV resistance
- **Disadvantages**: Can string, not as easy to print as PLA
- **Ideal use**: Mechanical parts, containers, outdoor projects, food containers

## TPU (Thermoplastic Polyurethane)

A filament with flexible and rubber-like properties.

- **Print temperature**: 210-230°C
- **Bed temperature**: 30-60°C
- **Advantages**: Flexible, shock absorbing, wear resistant
- **Disadvantages**: Must be printed slowly, difficult with Bowden systems
- **Ideal use**: Phone cases, shoe soles, shock absorber parts

## ASA (Acrylonitrile Styrene Acrylate)

The UV-resistant version of ABS.

- **Print temperature**: 235-260°C
- **Advantages**: Resistant to UV and weather conditions
- **Ideal use**: Outdoor parts, garden equipment, vehicle parts

## Which Filament Should You Choose?

| Need | Recommended Filament |
|------|---------------------|
| Just starting out | PLA |
| Need durable parts | PETG or ABS |
| Want flexible products | TPU |
| Outdoor use | ASA or PETG |
| Detailed figurines | PLA or PLA+ |

Sellers on 3DEra specify which filament type they use in their products. This way, you can easily find the product that best suits your needs.`
      },
      prepareModel: {
        title: 'How to Prepare a 3D Model? Step by Step from Design to Print',
        excerpt: 'Learn the transition from digital design to physical product. Slicing settings, support structures and print optimization.',
        content: `To start 3D printing, you first need a digital model. In this guide, we explain the entire process step by step, from model creation to printing.

## Step 1: Getting a 3D Model

You have three ways to get a model:

### Design It Yourself
- **Tinkercad**: Completely free, browser-based, ideal for beginners
- **Fusion 360**: Free for hobbyists, powerful for engineering projects
- **Blender**: Free, excellent for organic and artistic models

### Download Ready Models
On 3DEra, you can find thousands of print-ready models. Download in STL or OBJ format and use directly.

### 3D Scanning
Digitize real objects using smartphone apps or scanners.

## Step 2: Check Your Model

Before printing, make sure your model is "watertight":
- No open edges or holes
- Normals should face the correct direction
- Minimum wall thickness should be at least 1-2mm

After repairing the model with tools like Netfabb or Meshmixer, you're ready to print.

## Step 3: Slicing

Slicing software converts your 3D model into instructions that the printer can understand.

### Basic Slicing Settings

- **Layer height**: 0.2mm standard quality, 0.12mm high detail, 0.28mm fast print
- **Infill**: 15-20% decorative, 40-60% functional, 100% maximum durability
- **Print speed**: 40-60 mm/s standard, 30 mm/s for detailed prints
- **Support structures**: Add automatic supports for overhanging areas
- **Adhesion type**: Skirt, Brim, or Raft

### Popular Slicing Software
- **Cura**: Free, most common, wide printer support
- **PrusaSlicer**: Free, advanced settings, organic supports
- **Bambu Studio**: Optimized specifically for Bambu Lab printers

## Step 4: The Printing Process

1. Prepare the printer: load filament, level the bed
2. Watch the first layer — stop the print if adhesion is poor
3. Keep ambient temperature stable (enclosed environment is essential for ABS)
4. Don't leave the printer unattended (especially during first prints)

## Step 5: Post-Processing

- Carefully remove support structures
- Sand the surface smooth (80-400 grit)
- Apply primer for painting
- Use epoxy or filler if needed to fix imperfections

Models purchased on 3DEra usually come with recommended print settings, making it easier for you to get the best results.`
      },
      fdmVsSla: {
        title: 'FDM vs SLA: Which 3D Printing Method is Right for You?',
        excerpt: 'Detailed comparison of two popular 3D printing technologies. Evaluation in terms of cost, quality, speed and ease of use.',
        content: `Two main technologies stand out in the 3D printing world: FDM and SLA. Each has its own unique advantages and use cases. So which one is more suitable for your needs?

## FDM (Fused Deposition Modeling)

FDM is the most common 3D printing method that works by depositing melted plastic filament layer by layer.

### Advantages
- Low material cost
- Large print volumes possible
- Wide material selection (PLA, ABS, PETG, TPU, etc.)
- Easy maintenance, cheap spare parts
- Large and active user community

### Disadvantages
- Layer lines can be visible
- Limited on fine details
- Support structures can reduce surface quality
- Low precision on small parts

## SLA (Stereolithography)

SLA works by curing liquid photopolymer resin with UV light. It offers much higher resolution.

### Advantages
- Extraordinary surface quality
- Very fine details (0.025mm layers)
- Smooth surface, minimal post-processing
- Excellent for miniatures and jewelry molds

### Disadvantages
- Higher resin cost
- Small print volume (generally)
- Toxic resin, requires ventilation and protective equipment
- Post-print washing and UV curing steps
- Brittle results (with most standard resins)

## Comparison Table

| Feature | FDM | SLA |
|---------|-----|-----|
| Entry cost | Low | Medium-High |
| Material cost | Low | High |
| Surface quality | Medium | Very high |
| Detail precision | 0.1-0.2mm | 0.025-0.05mm |
| Print speed | Medium-Fast | Slow-Medium |
| Ease of maintenance | Easy | Difficult |
| Safety | Safe | Chemical risks |
| Print volume | Large | Small-Medium |

## Which Should You Choose?

**Choose FDM** if:
- You're new to 3D printing
- You'll print functional parts and prototypes
- Your budget is limited
- You need to print large objects

**Choose SLA** if:
- You'll print highly detailed miniatures or jewelry
- Smooth surface quality is critical
- You'll produce small, detailed parts
- You'll make dental or medical models

Sellers on 3DEra offer both FDM and SLA printing services. You can easily find the seller that offers the right printing method for your project.`
      },
      sellingPrints: {
        title: 'Guide to Making Money Selling 3D Printed Products',
        excerpt: 'Turn your 3D printer into a source of income. Opening a store on 3DEra, product listing and sales strategies.',
        content: `Your 3D printer is not just a hobby tool — it can also be a business opportunity. In this guide, we explain how you can earn income by selling 3D printed products.

## What Can You Sell?

### Ready 3D Models (Digital Files)
- Sell as STL/OBJ files
- Design once, sell unlimited times
- No production cost, pure profit

### Printed Products (Physical)
- Decorative objects, vases, planters
- Functional parts, organizers
- Personalized gifts
- Cosplay accessories and figurines
- Phone cases and holders

### Printing Service
- Print customers' models
- Design + print package service
- Prototype production

## Getting Started on 3DEra

### 1. Create a Seller Account
Apply from the "Become a Seller" page on 3DEra. Enter your store name, seller type (designer, printer, or both) and your information.

### 2. Choose Your Tax Status
During registration you must choose one of two options:

- **Tax-Exempt**: For individual sellers. Upload your tax exemption letter. No obligation to issue invoices on sales.
- **Company / Firm**: For legal entities. Upload your tax certificate and issue invoices on sales.

Consult your accountant if you're unsure which applies to you.

### 3. Application Approval
Your application is reviewed and approved by our admin team. Your store becomes active after approval.

### 4. Add Products
List your products by entering product photos, description, price and category information. You can also sell digital models by uploading 3D files.

### 5. Order Management
Track incoming orders from your seller panel, update their status, and communicate with customers.

## Pricing Strategies

- **Material cost**: Calculate filament usage (weight x filament price/kg)
- **Electricity and depreciation**: Include printer and electricity costs
- **Labor**: Your design, preparation and post-processing time
- **Profit margin**: Aim for a minimum 30-50% profit margin
- **Market research**: Review prices of similar products

## Tips for Success

1. **Take quality photos**: Well-lit photos from different angles increase sales
2. **Write detailed descriptions**: Add size, material, color, and use case information
3. **Deliver fast**: Keep shipping times short for customer satisfaction and good reviews
4. **Stay in touch**: Actively use the 3DEra messaging system
5. **Expand your portfolio**: Regularly add new products

3DEra is Turkey's marketplace bringing 3D printing enthusiasts together. Become a seller today and reach thousands of potential customers with your products!`
      },
      troubleshooting: {
        title: '3D Printing Problems and Solutions',
        excerpt: 'Causes of common problems such as layer shifting, stringing, warping and practical solutions.',
        content: `Every 3D printing user encounters problems from time to time. In this guide, you'll find the most common issues and their proven solutions.

## 1. Warping

The corners of the print lift from the bed and curl up.

**Causes:**
- Bed temperature too low
- Ambient temperature too cold
- Poor first layer adhesion

**Solutions:**
- Increase bed temperature (PLA: 60°C, ABS: 100°C)
- Use Brim or Raft
- Apply glue stick or hairspray to the bed surface
- Use an enclosed printer for ABS
- Reduce first layer speed by 50%

## 2. Stringing

The nozzle leaves thin filament strings while traveling between points.

**Causes:**
- Retraction settings insufficient
- Nozzle temperature too high
- Print speed too slow

**Solutions:**
- Increase retraction distance (Bowden: 4-8mm, Direct Drive: 0.5-2mm)
- Set retraction speed to 25-50 mm/s
- Lower nozzle temperature by 5-10°C
- Increase travel speed (150-200 mm/s)

## 3. Layer Shifting

The print shifts sideways from a certain point.

**Causes:**
- Loose belts
- Overheating stepper motor drivers
- Print speed too high
- Nozzle hitting the print

**Solutions:**
- Tighten belts (should twang but not be overtight)
- Check motor driver current
- Reduce print speed
- Check Z-offset

## 4. First Layer Not Sticking

The first layer doesn't adhere properly to the bed.

**Causes:**
- Bed not level
- Nozzle too close or too far from bed
- Dirty bed surface
- First layer speed too high

**Solutions:**
- Re-level the bed
- Adjust Z-offset (paper test)
- Clean the bed with IPA (isopropyl alcohol)
- Set first layer speed to 20-25 mm/s
- Increase first layer height (120-150%)

## 5. Clogging

Filament doesn't come out of the nozzle or comes out irregularly.

**Causes:**
- Nozzle temperature too low
- Low quality filament
- Heat leak in the heat break area
- Worn nozzle

**Solutions:**
- Set nozzle to recommended temperature
- Clean with cold pull method
- Replace the nozzle (especially 0.4mm brass nozzles wear out)
- Use quality filament
- Reduce retraction distance (heat creep prevention)

## 6. Elephant Foot

The first few layers expand, creating a bulge at the base.

**Causes:**
- Nozzle too close to bed
- Bed temperature too high
- First layer flow too high

**Solutions:**
- Slightly increase Z-offset
- Lower bed temperature by 5°C
- Reduce first layer flow rate to 95%

## General Tips

- **Change only one setting at a time** during each troubleshooting attempt
- Print a temperature tower to find the best temperature
- Perform regular maintenance: nozzle cleaning, bed checks, belt tension
- Store filaments in a dry environment (moisture degrades quality)
- Get help from community forums

On 3DEra, you can directly message experienced 3D printing sellers for technical support.`
      },
    },
  },
  auth: {
    signIn: 'Sign In',
    signUp: 'Sign Up',
    withGoogle: 'With Google',
    continue: 'Continue',
    persistNote: 'Your login will be persistent on this device (until you sign out).',
    or: 'or',
    firstName: 'First Name',
    lastName: 'Last Name',
    dateOfBirth: 'Date of Birth',
    ageRequirement: 'You must be over 18 years old',
    phoneOptional: 'Phone (Optional)',
    email: 'Email',
    password: 'Password',
    passwordExample: 'E.g: Password123!',
    minChars: 'At least 6 characters',
    confirmPassword: 'Confirm Password',
    reenterPassword: 'Re-enter password',
    passwordMismatch: '⚠️ Passwords do not match',
    terms: 'Terms of Use',
    termsAccept: 'I have read and accept.',
    kvkk: 'KVKK Privacy Notice',
    kvkkAccept: 'I accept the processing of my personal data.',
    rememberMe: 'Remember Me',
    processing: 'Processing...',
    uppercaseReq: 'Password must contain at least 1 uppercase letter.',
    numberReq: 'Password must contain at least 1 number.',
    specialReq: 'Password must contain at least 1 special character (!@#$%^&* etc.).',
    underAge: 'Users under 18 cannot register.',
    acceptTerms: 'Please read and accept the Terms of Use and KVKK Privacy Notice.',
    loginSuccess: 'Sign in successful! Welcome 🎉',
    registerSuccess: 'Registration successful! Your account has been created 🎉',
    googleError: 'An error occurred while signing in with Google.',
    accountDisabled: 'Your account has been disabled. You cannot sign in with this account.',
    firstNameMin: 'First name must be at least 2 characters.',
    lastNameMin: 'Last name must be at least 2 characters.',
    enterEmail: 'Enter email address.',
    passwordsMismatch: 'Passwords do not match.',
    passwordMin: 'Password must be at least 6 characters.',
    passwordMax: 'Password can be at most 50 characters.',
    enterDob: 'Enter your date of birth.',
    phoneMin: 'Phone number must be at least 10 digits.',
    unexpectedError: 'An unexpected error occurred.',
    fillAllFields: 'Fill in all fields, meet password requirements and accept legal documents',
    uppercase: 'Uppercase (A-Z)',
    number: 'Number (0-9)',
    specialChar: 'Special character (!@#$%^&*)',
    onlyLetters: 'You can only use letters',
    onlyNumbers: 'You can only use numbers and spaces',
    firstNameMax: 'First name can be at most 50 characters.',
    lastNameMax: 'Last name can be at most 50 characters.',
    phoneMax: 'Phone number can be at most 15 digits.',
    emailMax: 'Email can be at most 100 characters.',
  },
  becomeSeller: {
    title: 'Become a Seller',
    alreadySeller: 'You already have a seller account. You are being redirected to your profile page.',
    storeNameMax: 'Store name can be at most 100 characters.',
  },
  common: {
    loading: 'Loading...',
    error: 'An error occurred.',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    close: 'Close',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    search: 'Search',
    noResults: 'No results found.',
    backHome: '← Home',
  },
  messages: {
    search: 'Search conversations...',
    noConversations: 'No messages yet',
    noMessages: 'No messages yet. Send the first one!',
    typeMessage: 'Type a message...',
    hideConfirm: 'Are you sure you want to hide this conversation?',
    deleteConfirm: 'Are you sure you want to delete this message?',
    selectConversation: 'Select a conversation',
  },
};
